// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader-module--container--2KDUz","isHidden":"Loader-module--isHidden--gf_Uz","shell":"Loader-module--shell--1F54u","pulse":"Loader-module--pulse--3jb1b"};